import React from 'react';
import PropTypes from 'prop-types';

import { PriceHistoryPopup } from '../../../../Price/index';
import { Price as FinancePrice } from '../../../../../classes/finance/index';
import { fixedPrice } from '../../../../../utils/formater';
import { SALE } from '../../../../../consts';

function Price (props) {
  /** @var Announcement */
  const item = props.item;

  const priceInfo = FinancePrice.getPriceInfo(item);
  const priceHistory = item.getPriceHistory();
  const dealCondition = item.getDealCondition();
  const rentPeriod = dealCondition.getRentPeriod();

  const deal = item.getDeal();

  const getLabel = () => (item.getDealType() === SALE ? 'продан' : 'сдан') + ' по цене:';

  const getSoldPrice = () => {
    const price = priceInfo.priceValue;
    const priceSold = deal.getPrice().getValue();

    if (price === priceSold) {
      return (
        <div className='deal'>
          <div className='deal-label'>{getLabel()}</div>
          <span className='main-param'>
            {priceInfo.price}
          </span>
          { priceInfo.perAre && (<div>{priceInfo.perAre}</div>) }
          { priceInfo.perSquareMeter && (<div>{priceInfo.perSquareMeter}</div>) }
        </div>
      );
    }

    return (
      <div className='deal price-diff'>
        <div className='original-deal'>
          <span className='main-param'>
            {priceInfo.price}
          </span>
          { priceInfo.perAre && (<div>{priceInfo.perAre}</div>) }
          { priceInfo.perSquareMeter && (<div>{priceInfo.perSquareMeter}</div>) }
        </div>

        <div className='result-deal'>
          <div className='deal-label'>{getLabel()}</div>
          <span className='main-param'>
            { deal.getPrice().getLabel() }
          </span>
          <div className={'inequality-price ' + (priceSold - price > 0 ? 'plus' : 'minus')}>{ fixedPrice(priceSold - price) }</div>
          { deal.getPricePerAre() && (<div>{deal.getPricePerAre().getLabel(FinancePrice.PER_AR)}</div>) }
          { deal.getPricePerSquareMeter() && (<div>{deal.getPricePerSquareMeter().getLabel(FinancePrice.PER_SQUARE_METER)}</div>) }
        </div>
      </div>
    );
  };

  const getCurrentPrice = () => {
    return (
      <div>
        <PriceHistoryPopup
          history={priceHistory}
          dealType={item.getDealType()}
          realtyType={item.getRealtyType()}
          realtyId={item.getProperty().getId()}
        >
          <span className='main-param'>
            {priceInfo.price}
          </span>
        </PriceHistoryPopup>

        { priceInfo.perAre && (<div>{priceInfo.perAre}</div>) }
        { priceInfo.perSquareMeter && (<div>{priceInfo.perSquareMeter}</div>) }
      </div>
    );
  };

  return (
    <td className='col-price'>
      {
        deal ? getSoldPrice() : getCurrentPrice()
      }

      { priceInfo.utilities && (<div>{priceInfo.utilities}</div>) }
      { priceInfo.deposit && (<div>{priceInfo.deposit}</div>) }

      <div>
        {
          [
            dealCondition.getLabelClearSale(),
            dealCondition.getLabelExchange(),
            dealCondition.getLabelExchangePicked(),
            dealCondition.getLabelExclusive(),
            priceInfo.commission,
            rentPeriod && rentPeriod.get('fullName')
          ].filter(Boolean).join(', ')
        }
      </div>
    </td>
  );
}

Price.propTypes = {
  item: PropTypes.object.isRequired
};

export default Price;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/GridCells/Price.jsx